// Native Date/epoch comparisons match subscription-banner and DateUtil conventions.
// America/New_York is EDT (UTC-04:00) for both September 2026 windows.
// Starts are inclusive; Monday 08:00 Eastern cutoffs are exclusive, as requested.
export const EMAIL_REPORTS_BANNER_WINDOWS = [
  { start: '2026-09-11T08:00:00-04:00', end: '2026-09-14T08:00:00-04:00' },
  { start: '2026-09-18T08:00:00-04:00', end: '2026-09-21T08:00:00-04:00' },
] as const;

export function getEmailReportsBannerWindow(currentDate: Date = new Date()) {
  const time = currentDate.getTime();
  return EMAIL_REPORTS_BANNER_WINDOWS.find(
    ({ start, end }) => time >= new Date(start).getTime() && time < new Date(end).getTime()
  );
}

export function shouldShowEmailReportsBanner(currentDate: Date = new Date()): boolean {
  return !!getEmailReportsBannerWindow(currentDate);
}
